export const PAYPAL_SETTING_ERROR = 'PAYPAL_SETTING_ERROR';
export const PAYPAL_SETTING_REQUEST = 'PAYPAL_SETTING_REQUEST';
export const PAYPAL_SETTING_SUCCESS = 'PAYPAL_SETTING_SUCCESS';
export const PAYPAL_SETTING_RESET = 'PAYPAL_SETTING_RESET';
